import { ReactElement } from "react";

import AuthTransactionProvider from "./providers/authTransaction/AuthTransactionProvider";

import RegisterContainer from "./components/registerContainer/RegisterContainer";

import { setUpAuthQueryParamData } from "./util/getAuthQueryParamData";

const Register = (): ReactElement => {
  setUpAuthQueryParamData();

  return (
    <AuthTransactionProvider>
      <RegisterContainer />
    </AuthTransactionProvider>
  );
};

export default Register;
